export interface Module {
  num: string
  title: string
  description: string
}

export const modules: Module[] = [
  {
    num: '1',
    title: 'Fondamenti della Domotica™',
    description:
      'Parti dalle basi e comprendi realmente come funziona una Smart Home. Scopri sensori, attuatori, relè, hub, bridge, gateway e controller insieme ai principali protocolli come Wi-Fi, Bluetooth, Zigbee, Z-Wave, Thread e Matter. Impara a interpretare compatibilità, requisiti e specifiche per arrivare alla configurazione del tuo primo piccolo ecosistema Smart Home funzionante.',
  },
  {
    num: '2',
    title: 'Progettazione e Preparazione dell’Impianto™',
    description:
      'Impara a trasformare un’abitazione in un progetto Smart Home organizzato. Analizza ambienti ed esigenze, suddividi la casa in zone, definisci funzioni e automazioni, scegli protocolli e dispositivi, valuta la copertura della rete e prepara materiali e sequenza del progetto. Passa dall’idea iniziale a una struttura concreta prima di iniziare qualsiasi configurazione.',
  },
  {
    num: '3',
    title: 'Installazione e Configurazione Pratica™',
    description:
      'Trasforma il progetto in un sistema funzionante. Impara a configurare hub, gateway, sensori, illuminazione, prese smart, climatizzazione, accessi e altri dispositivi attraverso procedure organizzate. Verifica pairing, connessioni, copertura e risposta dei dispositivi e utilizza un processo di test progressivo per individuare eventuali problemi prima di procedere.',
  },
  {
    num: '4',
    title: 'Automazioni e Scenari Intelligenti™',
    description:
      'Vai oltre il semplice controllo tramite app e inizia a creare una casa che reagisce automaticamente alle condizioni reali. Lavora con trigger, condizioni e azioni per costruire automazioni dedicate a illuminazione, comfort, climatizzazione, sicurezza, presenza, routine quotidiane ed efficienza energetica, partendo da scenari semplici fino a logiche più articolate.',
  },
  {
    num: '5',
    title: 'Integrazione Smart Home Avanzata™',
    description:
      'Impara a collegare dispositivi, protocolli ed ecosistemi differenti in una struttura più organizzata. Comprendi Matter e Thread nella pratica e scopri come Apple Home, Google Home, Amazon Alexa e Home Assistant possono inserirsi in un progetto Smart Home. Lavora con controllo centralizzato, utenti, accessi, backup, aggiornamenti, privacy, sicurezza e troubleshooting delle integrazioni.',
  },
  {
    num: '6',
    title: 'Progetti Smart Home Completi™',
    description:
      'Metti insieme tutto ciò che hai imparato attraverso progetti progressivi e realistici. Parti da un monolocale Smart e passa ad appartamenti, case familiari, sistemi orientati all’efficienza energetica e configurazioni avanzate. Segui ogni progetto dall’analisi iniziale alla scelta dei dispositivi, configurazione, automazione, integrazione, test, collaudo e documentazione finale.',
  },
]

export const promises = [
  'Imparare seguendo un ordine preciso.',
  'Comprendere dispositivi e protocolli.',
  'Progettare prima di installare.',
  'Configurare sistemi Smart Home.',
  'Creare automazioni realmente utili.',
  'Integrare dispositivi ed ecosistemi.',
  'Passare dalla teoria all’applicazione pratica.',
]
